import { i18n } from '../i18n';
import { parseToIsoDate } from './dateFormat';
import { validationMaxCharLimit } from './validationI18n';

export function maxCharLimitExceededError(): string {
  return validationMaxCharLimit();
}

/** @deprecated Use maxCharLimitExceededError() for translated messages. */
export const MAX_CHAR_LIMIT_EXCEEDED = 'Max character limit exceeded.';

export function sliceMax(v: string, max: number): string {
  return v.slice(0, max);
}

export function boundedText(
  raw: string,
  max: number,
): { value: string; limitExceeded: boolean } {
  return { value: sliceMax(raw, max), limitExceeded: raw.length > max };
}

export function maxLengthLimitError(limitExceeded: boolean): string {
  return limitExceeded ? maxCharLimitExceededError() : '';
}

export function exceedsMax(v: string, max: number): boolean {
  return v.trim().length > max;
}

/** CMS contact number — numeric, exactly 10 digits (e.g. 07XXXXXXXX). */
export const CONTACT_NUMBER_LENGTH = 10;

export function contactNumberError(value: string): string | undefined {
  const digits = value.trim();
  if (!digits) return undefined;
  if (!/^0\d{9}$/.test(digits)) return i18n.t('validation.validContactNumber');
  return undefined;
}

/** Today's date in local timezone as `YYYY-MM-DD`. */
export function todayIsoDateLocal(): string {
  const d = new Date();
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

/** Tomorrow's date in local timezone as `YYYY-MM-DD`. */
export function tomorrowIsoDateLocal(): string {
  const d = new Date();
  d.setDate(d.getDate() + 1);
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

export function isFutureIsoDate(date: string): boolean {
  const iso = parseToIsoDate(date);
  return Boolean(iso) && iso > todayIsoDateLocal();
}

/** True when the date is today or later (local timezone). */
export function isTodayOrFutureIsoDate(date: string): boolean {
  const iso = parseToIsoDate(date);
  return Boolean(iso) && iso >= todayIsoDateLocal();
}

export function calcAgeFromDob(dob: string): number | null {
  if (!dob) return null;
  const iso = parseToIsoDate(dob);
  const dt = new Date(iso || dob);
  if (Number.isNaN(dt.getTime())) return null;
  const now = new Date();
  let age = now.getFullYear() - dt.getFullYear();
  const m = now.getMonth() - dt.getMonth();
  if (m < 0 || (m === 0 && now.getDate() < dt.getDate())) age--;
  return age;
}
